<script setup lang="ts"></script>

<template>
  <section class="body-font container relative text-gray-600">
    <h1 class="title">Info and contact</h1>

    <div class="flex-row gap-10 md:flex">
      <div class="w-full md:w-1/2">
        <h2 class="subtitle">How to subscribe</h2>

        <p class="mt-2">
          Online subscription to Studi Musicali is included with the paper format subscription to the journal. Online
          subscription only is not currently possible.
        </p>

        <p class="mt-2">
          To subscribe users can send an email to
          <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a> with
          their subscription request. Payments can be made with:
        </p>

        <ol class="list-inside">
          <li class="mt-5">
            <strong>Bank transfer</strong><br />
            IBAN: “IT 31 I 01005 03240 000000009872” - SWIFT/BIC: “BNL II TRR” - BNL<br />
            Bank name: “Gruppo BNP Paribas”<br />
            Bank address: Via del Corso, 471 - 00186 Roma C/c<br />
            Bank account holder: “Fondazione Accademia Nazionale di Santa Cecilia”<br />
          </li>
        </ol>

        <p class="mt-5">
          <strong>
            Causale: “Abbonamento Studi Musicali per l'anno 20XX”.<br />
            Terms of use apply to subscriptions. Please read carefully before subscribing.
          </strong>
        </p>
      </div>

      <div class="mt-5 w-full md:mt-0 md:w-1/2">
        <h2 class="subtitle">Rules for online access</h2>

        <p class="mt-2">
          Subscribers to the Studi Musicali journal can also access the periodical online providing at the time of
          subscription the name and email address of those who will manage accesses. It is also possible to print the
          articles or parts of them.
        </p>

        <p class="mt-2">For any information or reporting malfunctions please contact the following:</p>

        <ul class="classic-ul">
          <li class="mt-5">
            <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a>
          </li>
          <li class="mt-5">tel. +39-06-80242526</li>
          <li class="mt-5">fax +39-06-80242306</li>
        </ul>
      </div>
    </div>

    <hr class="my-10 border-gray-300" />

    <div>
      <h2 class="subtitle">Advertisement</h2>
      <p class="mt-2">
        For advertisements on the journal please contact:
        <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a>
      </p>
    </div>

    <div class="mt-5">
      <h2 class="subtitle">Subscription conditions</h2>
      <p class="mt-2">
        Subscribers receive the Studi Musicali journal in print format on a semi-annual basis and have full access to
        the online digital version of all issues, up to the latest one published. Please note that the two issues of the
        journal are published in June and December of the reference year.
      </p>

      <div class="my-5 flex-row md:flex">
        <ul class="classic-ul w-full md:w-1/2">
          <li>Italy subscription - istituzioni: <strong>85,00 euros</strong></li>
          <li>Italy subscription - private: <strong>70,00 euros</strong></li>
        </ul>

        <ul class="classic-ul w-full md:w-1/2">
          <li>Foreign subscription - institutions: <strong>110,00 euros</strong></li>
          <li>Foreign subscription - private: <strong>90,00 euros</strong></li>
        </ul>
      </div>

      <p>
        The shipping costs for the subscription are covered by the publisher. For subscription fees for previous years,
        please contact us at:
        <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a>
      </p>
    </div>

    <div class="mt-5">
      <h2 class="subtitle">Back Issues and individual issues</h2>

      <p>Back issues can be purchased by year (90.00 euros per year) or individual numbers (50.00 euros each).</p>
    </div>
  </section>
</template>
